import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT } from './view'

export const NAMESPACE = 'KanBo/Board/documentSources/'
export const SET_DEFAULT_DOCUMENT_SOURCE = NAMESPACE + 'SET_DEFAULT_DOCUMENT_SOURCE'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_DOCUMENT_SOURCE = NAMESPACE + 'SET_DOCUMENT_SOURCE'

const documentSourceDefaults = {
  boards: [],
  isLoading: false,
  isLoaded: false,
  access: null
}

const defaultBoardState = {
  defaultDocumentSource: null,
  documentSources: [],
  isLoading: false,
  isLoaded: false
}

const initialState = {
  documentSourcesById: {},
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.boardId]: {
          ...defaultBoardState,
        }
      }
    case SET_DEFAULT_DOCUMENT_SOURCE:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          defaultDocumentSource: action.payload.documentSourceId
        }
      } : state
    case SET_LOAD_STATUS:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          isLoading: action.payload.isLoading,
          isLoaded: action.payload.isLoaded
        }
      } : state
    case ADD:
      return state[action.payload.boardId] ? {
        ...state,
        documentSourcesById: {
          ...state.documentSourcesById,
          [action.payload.documentSource.id]: {
            ...documentSourceDefaults,
            ...state.documentSourcesById[action.payload.documentSource.id],
            ...action.payload.documentSource
          }
        },
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          documentSources: addUniqueValueToArray({
            array: state[action.payload.boardId].documentSources,
            value: action.payload.documentSource.id,
            index: action.payload.documentSource.index
          }),
        }
      } : state
    case ADD_ARRAY: {
      if (!state[action.payload.boardId]) return state

      const newState = {
        ...state,
        documentSourcesById: { ...state.documentSourcesById },
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          documentSources: [ ...state[action.payload.boardId].documentSources ],
        }
      }

      action.payload.array.forEach(item => {
        newState[action.payload.boardId].documentSources = addUniqueValueToArray({
          array: newState[action.payload.boardId].documentSources,
          value: item.id,
          index: item.index
        })
        newState.documentSourcesById[item.id] = {
          ...documentSourceDefaults,
          ...newState.documentSourcesById[item.id],
          ...item
        }
      })

      return newState
    }
    case REMOVE: {
      if (!state[action.payload.boardId]) return state

      const newState = {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          documentSources: [ ...state[action.payload.boardId].documentSources.filter(id => id !== action.payload.documentSourceId) ],
        }
      }

      return newState
    }
    case SET_DOCUMENT_SOURCE:
      return {
        ...state,
        documentSourcesById: {
          ...state.documentSourcesById,
          [action.payload.documentSource.id]: {
            ...documentSourceDefaults,
            ...state.documentSourcesById[action.payload.documentSource.id],
            ...action.payload.documentSource
          }
        }
      }
    default: return state
  }
}

export function setDefaultDocumentSource ({ boardId, documentSourceId }) {
  return {
    type: SET_DEFAULT_DOCUMENT_SOURCE,
    payload: {
      boardId,
      documentSourceId,
    }
  }
}

export function setLoadStatus ({ boardId, isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      boardId,
      isLoading,
      isLoaded
    }
  }
}

export function add ({ boardId, documentSource }) {
  return {
    type: ADD,
    payload: {
      boardId,
      documentSource
    }
  }
}

export function addArray ({ boardId, array }) {
  return {
    type: ADD_ARRAY,
    payload: {
      boardId,
      array
    }
  }
}

export function remove ({ boardId, documentSourceId }) {
  return {
    type: REMOVE,
    payload: {
      boardId,
      documentSourceId
    }
  }
}

export function setDocumentSource ({ documentSource }) {
  return {
    type: SET_DOCUMENT_SOURCE,
    payload: {
      documentSource
    }
  }
}